var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 19.25H1.83337V17.4167H2.75004V3.66667C2.75004 3.42355 2.84662 3.19039 3.01853 3.01849C3.19043 2.84658 3.42359 2.75 3.66671 2.75H16.5C16.7432 2.75 16.9763 2.84658 17.1482 3.01849C17.3201 3.19039 17.4167 3.42355 17.4167 3.66667V8.25H19.25V17.4167H20.1667V19.25ZM15.5834 17.4167H17.4167V10.0833H11.9167V17.4167H13.75V11.9167H15.5834V17.4167ZM15.5834 8.25V4.58333H4.58337V17.4167H10.0834V8.25H15.5834ZM6.41671 10.0833H8.25004V11.9167H6.41671V10.0833ZM6.41671 13.75H8.25004V15.5833H6.41671V13.75ZM6.41671 6.41667H8.25004V8.25H6.41671V6.41667Z",
    fill: "#FDF7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.d31831afb64d566aa72f453002530474.svg";
export { ForwardRef as ReactComponent };